import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './SliderFilter.module.css';

const HANDLE_LEFT = 1;
const HANDLE_RIGHT = 2;

function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}

function autofocus(element) {
    if (element && element.focus) {
        element.focus();
    }
}

// DEPRECATED. Use troika or fabric alternatives.
export class SliderFilter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dragging: false,
            activeHandle: 0,
            selectBoxes: false,
        };

        this.sliderRef = React.createRef();
        this.thumbMinRef = React.createRef();
        this.thumbMaxRef = React.createRef();

        this.getStepFromMousePosition = this.getStepFromMousePosition.bind(this);
        this.isRange = this.isRange.bind(this);

        this.triggerOnChange = this.triggerOnChange.bind(this);

        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.startDragging = this.startDragging.bind(this);
        this.endDragging = this.endDragging.bind(this);
        this.drag = this.drag.bind(this);

        this.enableSelectBoxes = this.enableSelectBoxes.bind(this);
        this.disableSelectBoxes = this.disableSelectBoxes.bind(this);
    }

    componentWillUnmount() {
        window.removeEventListener('mousemove', this.drag);
        window.removeEventListener('touchmove', this.drag);
        window.removeEventListener('mouseup', this.endDragging);
        window.removeEventListener('touchend', this.endDragging);
    }

    startDragging(event, forceHandle) {
        const activeHandle = forceHandle || this.state.activeHandle;
        const clientX = event.clientX || event.touches[0].clientX;

        this.setState({ dragging: true, activeHandle });
        window.addEventListener('mousemove', this.drag);
        window.addEventListener('touchmove', this.drag);
        window.addEventListener('mouseup', this.endDragging);
        window.addEventListener('touchend', this.endDragging);

        this.triggerOnChange(this.getStepFromMousePosition(clientX), activeHandle);
    }

    endDragging() {
        this.disableSelectBoxes();
        this.setState({ dragging: false });
        window.removeEventListener('mousemove', this.drag);
        window.removeEventListener('touchmove', this.drag);
        window.removeEventListener('mouseup', this.endDragging);
        window.removeEventListener('touchend', this.endDragging);
    }

    isRange() {
        return Array.isArray(this.props.step);
    }

    getStepFromMousePosition(clientX) {
        const rect = this.sliderRef.current.getBoundingClientRect();
        return clamp(Math.round(((clientX - rect.left) / rect.width) * this.props.stepCount), 0, this.props.stepCount);
    }

    triggerOnChange(value, forceHandle) {
        const activeHandle = forceHandle || this.state.activeHandle;

        if (this.isRange()) {
            let [min, max] = this.props.step;

            if (activeHandle === HANDLE_LEFT) {
                min = clamp(value, 0, this.props.stepCount - 1);
                max = clamp(max, min + 1, this.props.stepCount);
            } else {
                max = clamp(value, 1, this.props.stepCount);
                min = clamp(min, 0, max - 1);
            }

            if (min !== this.props.step[0] || max !== this.props.step[1]) {
                this.props.onChange([min, max]);
            }
        } else {
            const newValue = clamp(value, 0, this.props.stepCount);

            if (newValue !== this.props.step) {
                this.props.onChange(newValue);
            }
        }
    }

    drag(event) {
        const clientX = event.touches ? event.touches[0].clientX : event.clientX;
        const step = this.getStepFromMousePosition(clientX);

        if (this.state.dragging) {
            if (event.buttons === 0 && (!event.touches || event.touches.length === 0)) {
                this.endDragging();
            } else {
                this.triggerOnChange(step);
            }
        }
    }

    handleKeyDown(event) {
        if (['ArrowLeft', 'ArrowDown', 'ArrowUp', 'ArrowRight', 'PageDown', 'PageUp'].includes(event.key)) {
            event.stopPropagation();
            event.preventDefault();
            const value = this.isRange() ? this.props.step[this.state.activeHandle - 1] : this.props.step;

            switch (event.key) {
                case 'ArrowLeft':
                case 'ArrowDown':
                    this.triggerOnChange(value - 1);
                    break;

                case 'ArrowUp':
                case 'ArrowRight':
                    this.triggerOnChange(value + 1);
                    break;

                case 'PageDown':
                    this.triggerOnChange(value - 5);
                    break;

                case 'PageUp':
                    this.triggerOnChange(value + 5);
                    break;
            }
        }
    }

    enableSelectBoxes() {
        this.setState({ selectBoxes: true });
    }

    disableSelectBoxes() {
        this.setState({ selectBoxes: false });
    }

    renderSelectBoxes() {
        const renderOptions = () => {
            const out = [];
            for (let i = 0; i < this.props.stepCount; i++) {
                out.push(
                    <option value={i} key={i}>
                        {this.props.getLabelForStep(i)}
                    </option>
                );
            }
            out.push(
                <option value={this.props.stepCount} key={this.props.stepCount}>
                    {this.props.getLabelForStep(this.props.stepCount)}
                </option>
            );
            return out;
        };

        return this.isRange() ? (
            <>
                <div className="input input--select input--kill-bottom-margin u-size1of2 u-float-left w-1/2 float-left">
                    <div className="input--select__wrap u-mr8">
                        <select
                            value={this.props.step[0]}
                            data-testid="slider-dropdown-min"
                            onChange={(e) => this.triggerOnChange(e.target.value, HANDLE_LEFT)}
                            ref={this.state.activeHandle === HANDLE_LEFT ? autofocus : null}>
                            {renderOptions()}
                        </select>
                    </div>
                </div>
                <div className="input input--select input--kill-bottom-margin u-size1of2 u-float-right w-1/2 float-right">
                    <div className="input--select__wrap u-ml8">
                        <select
                            value={this.props.step[1]}
                            data-testid="slider-dropdown-max"
                            onChange={(e) => this.triggerOnChange(e.target.value, HANDLE_RIGHT)}
                            ref={this.state.activeHandle === HANDLE_RIGHT ? autofocus : null}>
                            {renderOptions()}
                        </select>
                    </div>
                </div>
                <div className={styles.clearfix} />
            </>
        ) : (
            <div className="input input--select input--kill-bottom-margin u-size1of2">
                <div className="input--select__wrap u-mr8">
                    <select
                        value={this.props.step}
                        data-testid="slider-dropdown"
                        onChange={(e) => this.triggerOnChange(e.target.value)}
                        ref={autofocus}>
                        {renderOptions()}
                    </select>
                </div>
            </div>
        );
    }

    render() {
        const calculateSliderPosition = (step, right = false) => {
            if (right) {
                return `${clamp(1 - step / this.props.stepCount, 0, 1) * 100}%`;
            }

            return `${clamp(step / this.props.stepCount, 0, 1) * 100}%`;
        };

        const sliderMouseDown = (e) => {
            setTimeout(() => {
                this.thumbMinRef.current.focus();
            }, 0);
            this.startDragging(e, HANDLE_LEFT);
        };

        const setActiveHandle = (activeHandle) => () => {
            const thumbEl = activeHandle === HANDLE_LEFT ? this.thumbMinRef.current : this.thumbMaxRef.current;
            setTimeout(() => {
                thumbEl.focus();
            }, 0);
            this.setState({ activeHandle });
        };

        const thumbStartDrag = (activeHandle) => (event) => {
            setActiveHandle(activeHandle);
            this.startDragging(event, activeHandle);
        };

        const enableSelectBoxesAndSetFocus = (activeHandle) => () => {
            this.setState({ activeHandle }, this.enableSelectBoxes);
        };

        const handlers = {
            point: {
                slider: {
                    mousedown: sliderMouseDown,
                    mouseup: this.endDragging,
                    touchstart: sliderMouseDown,
                    touchend: this.endDragging,
                },
                thumb: {
                    mousedown: () => null,
                    mouseup: null,
                    keydown: this.handleKeyDown,
                    touchstart: () => null,
                    touchend: null,
                    focus: () => null,
                },
            },
            range: {
                slider: {
                    mousedown: null,
                    mouseup: null,
                    touchstart: null,
                    touchend: null,
                },
                thumb: {
                    mousedown: thumbStartDrag,
                    mouseup: this.endDragging,
                    keydown: this.handleKeyDown,
                    touchstart: thumbStartDrag,
                    touchend: this.endDragging,
                    focus: setActiveHandle,
                },
            },
        };

        const h = this.isRange() ? handlers.range : handlers.point;

        const ariaValuenow = this.isRange()
            ? (Array.isArray(this.props.ariaValuenow) && this.props.ariaValuenow[0]) || this.props.step[0]
            : this.props.ariaValuenow || this.props.step;

        return (
            <div className="u-position-relative u-size1of1 slider-filter">
                {this.props.title && <h3 className="u-t5 u-mb4 u-mh0">{this.props.title}</h3>}
                {this.state.selectBoxes ? (
                    this.renderSelectBoxes()
                ) : (
                    <div className="form-grid u-pl16">
                        <button
                            className="button button--link form-grid__unit form-grid__unit--g0 u-ph2"
                            onClick={enableSelectBoxesAndSetFocus(HANDLE_LEFT)}
                            data-testid="timeFilterDropdownFrom">
                            {this.isRange() ? this.props.label[0] : this.props.label}
                        </button>
                        {this.isRange() ? (
                            <>
                                &nbsp;&mdash;&nbsp;
                                <button
                                    className="button button--link form-grid__unit form-grid__unit--g0 u-ph2"
                                    onClick={enableSelectBoxesAndSetFocus(HANDLE_RIGHT)}
                                    data-testid="timeFilterDropdownTo">
                                    {this.props.label[1]}
                                </button>
                            </>
                        ) : null}
                        <div className="form-grid__unit form-grid__unit--g0 u-pv4 u-ph2 u-caption">{this.props.info}</div>
                    </div>
                )}

                <div className="u-pr16">
                    <div
                        className={`slider u-mh8 u-pr16 ${this.isRange() ? 'range' : 'point'}`}
                        data-testid="slider-container"
                        ref={this.sliderRef}
                        onMouseDown={h.slider.mousedown}
                        onTouchStart={h.slider.touchstart}>
                        <div className="slider__track-inactive" />
                        <div
                            className="slider__track-active"
                            style={{
                                left: this.isRange() ? calculateSliderPosition(this.props.step[0]) : 0,
                                right: this.isRange()
                                    ? calculateSliderPosition(this.props.step[1], true)
                                    : calculateSliderPosition(this.props.step, true),
                            }}
                        />
                        <div
                            className={cn(styles.thumbMin, 'slider__thumb')}
                            ref={this.thumbMinRef}
                            role="slider"
                            tabIndex={0}
                            aria-label={this.isRange() ? this.props.ariaLabel[0] : this.props.ariaLabel}
                            aria-valuemin={
                                (this.isRange()
                                    ? Array.isArray(this.props.ariaValuemin) && this.props.ariaValuemin[0]
                                    : this.props.ariaValuemin) || 0
                            }
                            aria-valuemax={
                                (this.isRange()
                                    ? Array.isArray(this.props.ariaValuemax) && this.props.ariaValuemax[0]
                                    : this.props.ariaValuemax) || this.props.stepCount - (this.isRange() ? 1 : 0)
                            }
                            aria-valuenow={ariaValuenow}
                            aria-valuetext={
                                (this.isRange()
                                    ? Array.isArray(this.props.ariaValuetext) && this.props.ariaValuetext[0]
                                    : this.props.ariaValuetext) ||
                                this.props.getLabelForStep(this.isRange() ? this.props.step[0] : this.props.step)
                            }
                            style={{
                                left: this.isRange()
                                    ? calculateSliderPosition(this.props.step[0])
                                    : calculateSliderPosition(this.props.step),
                                zIndex: this.state.activeHandle === HANDLE_LEFT ? 1 : 'initial',
                            }}
                            onMouseDown={h.thumb.mousedown(HANDLE_LEFT)}
                            onTouchStart={h.thumb.touchstart(HANDLE_LEFT)}
                            onKeyDown={h.thumb.keydown}
                            onFocus={h.thumb.focus(HANDLE_LEFT)}
                        />
                        {this.isRange() && (
                            <div
                                className={cn(styles.thumbMax, 'slider__thumb')}
                                ref={this.thumbMaxRef}
                                role="slider"
                                tabIndex={0}
                                aria-label={this.props.ariaLabel[1]}
                                aria-valuemin={(Array.isArray(this.props.ariaValuemin) && this.props.ariaValuemin[1]) || 1}
                                aria-valuemax={
                                    (Array.isArray(this.props.ariaValuemax) && this.props.ariaValuemax[1]) || this.props.stepCount
                                }
                                aria-valuenow={(Array.isArray(this.props.ariaValuenow) && this.props.ariaValuenow[1]) || this.props.step[1]}
                                aria-valuetext={
                                    (this.isRange()
                                        ? Array.isArray(this.props.ariaValuetext) && this.props.ariaValuetext[1]
                                        : this.props.ariaValuetext) ||
                                    this.props.getLabelForStep(this.isRange() ? this.props.step[1] : this.props.step)
                                }
                                style={{
                                    right: calculateSliderPosition(this.props.step[1], true),
                                    zIndex: this.state.activeHandle === HANDLE_RIGHT ? 1 : 'initial',
                                }}
                                onMouseDown={h.thumb.mousedown(HANDLE_RIGHT)}
                                onTouchStart={h.thumb.touchstart(HANDLE_RIGHT)}
                                onKeyDown={h.thumb.keydown}
                                onFocus={h.thumb.focus(HANDLE_RIGHT)}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

SliderFilter.propTypes = {
    title: PropTypes.string,
    info: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    getLabelForStep: PropTypes.func.isRequired,
    step: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]).isRequired,
    stepCount: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    ariaLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
    ariaValuemin: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
    ariaValuemax: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
    ariaValuenow: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number]),
    ariaValuetext: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};
